import { render, staticRenderFns } from "./SpaceConfigurationFeatures.vue?vue&type=template&id=5116ab24&"
import script from "./SpaceConfigurationFeatures.vue?vue&type=script&lang=js&"
export * from "./SpaceConfigurationFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports